import { Button, Grid } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { inviteAdmin } from '../../../actions/userActions'
import { useEmailValidator } from '../../../hooks/useEmailValidator'
import { useInput } from '../../../hooks/useInput'
import SelectInput from '../../Form/SelectInput'
import TextInput from '../../Form/TextInput'
import Message from '../../Message/Message'

const AddAdminUser = ({ setShowAddUser }) => {
  const dispatch = useDispatch()

  const { error } = useSelector((state) => state.userInvite)

  const {
    value: firstName,
    bind: bindFirstName,
    error: firstNameError,
    setError: setFirstNameError,
  } = useInput('')
  const {
    value: lastName,
    bind: bindLastName,
    error: lastNameError,
    setError: setLastNameError,
  } = useInput('')
  const {
    value: email,
    bind: bindEmail,
    error: emailError,
    setError: setEmailError,
  } = useInput('')
  const {
    value: role,
    bind: bindRole,
    error: roleError,
    setError: setRoleError,
  } = useInput('')
  const emailIsValid = useEmailValidator(email)

  const formIsValid = () => {
    let ready = true

    if (firstName === '') {
      ready = false
      setFirstNameError('Please enter a first name')
    } else {
      setFirstNameError('')
    }

    if (lastName === '') {
      ready = false
      setLastNameError('Please enter a last name')
    } else {
      setLastNameError('')
    }

    if (email === '') {
      ready = false
      setEmailError('Please enter an email address')
    } else if (!emailIsValid) {
      ready = false
      setEmailError('Please enter a valid email')
    } else if (!email.includes('@hexagon.com')) {
      ready = false
      setEmailError('Email must be a Hexagon account')
    } else {
      setEmailError('')
    }

    if (role === '') {
      ready = false
      setRoleError('Please select a user role')
    } else {
      setRoleError('')
    }

    return ready
  }

  const handleInviteUser = () => {
    if (formIsValid()) {
      const newUser = {
        firstName,
        lastName,
        email,
        role,
      }
      dispatch(inviteAdmin(newUser))
    }
  }

  return (
    <div className="form-container">
      <h4>Add member</h4>

      <Grid container spacing={2} className="m-t-16">
        <Grid item xs={6}>
          <TextInput
            name="firstName"
            label="First name"
            bindValue={bindFirstName}
            error={firstNameError}
          />
        </Grid>

        <Grid item xs={6}>
          <TextInput
            name="lastName"
            label="Last name"
            bindValue={bindLastName}
            error={lastNameError}
          />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            name="email"
            label="Email"
            bindValue={bindEmail}
            error={emailError}
          />
        </Grid>

        <Grid item xs={6}>
          <SelectInput
            label="Role"
            name="role"
            options={[
              { value: 'Manager', label: 'Manager' },
              { value: 'AE', label: 'AE' },
              { value: 'Support', label: 'Support' },
            ]}
            bindValue={bindRole}
            error={roleError}
          />
        </Grid>
      </Grid>

      <div className="flex flex-end m-t-30">
        <div>
          <Button
            variant="outlined"
            className="m-r-32"
            color="primary"
            onClick={() => setShowAddUser(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleInviteUser}
          >
            Save
          </Button>
        </div>
      </div>

      {error && <Message variant="error">{error}</Message>}
    </div>
  )
}

export default AddAdminUser
